import {Buttons} from '@esgillc/ui-kit/button';
import {useCloseModal, useModal} from '@esgillc/ui-kit/modal';
import {Alert} from '@esgillc/ui-kit/modal';

interface Props {
	totalPossible: number;
	onClose: () => void;
}

export function IncorrectScoreAlert(props: Props) {
	const modal = useModal();
	const close = useCloseModal(modal, props.onClose);
	return <Alert modalManagerRef={modal}>
		<Alert.Body>
			The max score on this test is {props.totalPossible}, please enter a score equal to or less
			than {props.totalPossible}
		</Alert.Body>
		<Alert.Footer>
			<Buttons.Text onClick={close}>OK</Buttons.Text>
		</Alert.Footer>
	</Alert>;
}
